import React, {useEffect, useState} from 'react'
import BoxOverview from "./overview/BoxOverview";
import TableBalance from "./lists/TableBalance";
import {getUserBilling, getUserTransaction} from "../../../../services/api/apiTransaction";
import parseToken from "../../../../helpers/parseToken";
import {Pagination} from "antd";

function BalanceManagerPage() {
    const [limit, setLimit] = useState(50)
    const [page, setPage] = useState(1)
    const [total, setTotal] = useState(0)
    const [loading, setLoading] = useState(false)
    const [loading1, setLoading1] = useState(false)
    const [error, setError] = useState('')
    const [error1, setError1] = useState('')
    const [balanceOverview, setBalanceOverview] = useState({})
    const [userTransaction, setUserTransaction] = useState({})
    const info = parseToken()

    const _onChangeLimit = (page, pageSize) => {
        setLimit(pageSize)
        setPage(pageSize !== limit ? 1 : page)
    }

    const _getUserBilling = async () => {
        setLoading1(true)
        setError1('')

        try {

            const response = await getUserBilling(info.sub, {})

            const {success, data, message, totalRecord} = response

            if (parseInt(success) !== 1) {
                return setError1(message)
            }

            setTotal(totalRecord)
            setBalanceOverview(data.length > 0 ? data[0] : {})
        } catch (e) {
            setLoading1(false)
            setError1(e.message)
        } finally {
            setLoading1(false)
        }
    }

    const _getUserTransaction = async () => {
        setLoading(true)
        setError('')

        try {
            const payload = {
                page,
                limit
            }

            const response = await getUserTransaction(info.sub, payload)

            const {success, data, error_message} = response

            if (parseInt(success) !== 1) {
                return setError(error_message)
            }

            setUserTransaction(data)
        } catch (e) {
            setLoading(false)
            setError(e.message)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        _getUserBilling()
        _getUserTransaction()
        // eslint-disable-next-line
    }, [page, limit])

    return (
        <div className="BalanceManagerPage MonitoringPage  PageDefault">
            <div className="PageHeading d-flex align-items-center justify-content-between">
                <h1 className="PageTitle">Balance manager</h1>
                <div className="account-status">Account status: <span
                    className={balanceOverview.status || 'NA'}>{balanceOverview.status || 'N/A'}</span></div>
            </div>
            <BoxOverview loading={loading1} error={error1} balanceOverview={balanceOverview}/>
            <div className="TabsContainer PageTable">
                <div className="contentTabs mt-0">
                    <TableBalance loading={loading} error={error} userTransaction={userTransaction}/>
                    <div className="PagePagination">
                        <Pagination
                            className="PaginationCustom"
                            total={total}
                            pageSize={limit}
                            current={page}
                            onChange={_onChangeLimit}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BalanceManagerPage
